
  $(document).ready(function($) {
  "use strict";
        
    var desktopMenuQuery = window.matchMedia('(min-width: 1024px)');
    var desktopMenuItems = document.querySelectorAll('#header .dt-desktop-menu .menu-item-has-children');

    function getDirectChild(element, selector) {
      return Array.prototype.find.call(element.children, function(child) {
        return child.matches(selector);
      });
    }

    function positionCascade(item, panel) {
      if (!desktopMenuQuery.matches) return;

      panel.classList.remove('desktop-menu-edge-right', 'desktop-cascade-flip');

      var isTopLevel = item.parentElement && item.parentElement.classList.contains('dt-nav');
      var itemRect = item.getBoundingClientRect();
      var panelWidth = panel.offsetWidth;
      var viewportGutter = 16;

      if (isTopLevel && !item.classList.contains('has-mega-menu')) {
        if (itemRect.left + panelWidth > window.innerWidth - viewportGutter) {
          panel.classList.add('desktop-menu-edge-right');
        }
      } else if (!isTopLevel) {
        if (itemRect.right + panelWidth + 12 > window.innerWidth - viewportGutter) {
          panel.classList.add('desktop-cascade-flip');
        }
      }

      var availableHeight = Math.max(240, window.innerHeight - Math.max(viewportGutter, itemRect.top - 8) - viewportGutter);
      panel.style.setProperty('--desktop-menu-available-height', availableHeight + 'px');
    }

    function setDesktopMenuState(item, isOpen) {
      var trigger = getDirectChild(item, 'a');
      var panel = getDirectChild(item, '.sub-menu-block');
      if (!trigger || !panel) return;

      if (isOpen) positionCascade(item, panel);
      item.classList.toggle('desktop-menu-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    // v2.6.5: :has() desteklemeyen tarayicilar icin kirpma kapatma isareti.
    document.querySelectorAll('#header .dt-desktop-menu .sub-menu-lists').forEach(function (list) {
      if (!list.querySelector(':scope > li.menu-item-has-children')) return;
      list.classList.add('has-cascade');
      var block = list.closest('.sub-menu-block');
      if (block) block.classList.add('has-cascade');
    });

    desktopMenuItems.forEach(function(item) {
      var trigger = getDirectChild(item, 'a');
      var panel = getDirectChild(item, '.sub-menu-block');
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');

      item.addEventListener('mouseenter', function() {
        if (desktopMenuQuery.matches) {
          item.classList.remove('desktop-menu-escape-closed');
          setDesktopMenuState(item, true);
        }
      });

      item.addEventListener('mouseleave', function() {
        if (desktopMenuQuery.matches) setDesktopMenuState(item, false);
      });

      item.addEventListener('focusin', function(event) {
        if (!desktopMenuQuery.matches) return;
        if (item.classList.contains('desktop-menu-escape-closed') && event.target === trigger) return;
        item.classList.remove('desktop-menu-escape-closed');
        setDesktopMenuState(item, true);
      });

      item.addEventListener('focusout', function() {
        window.setTimeout(function() {
          if (desktopMenuQuery.matches && !item.contains(document.activeElement)) {
            setDesktopMenuState(item, false);
            item.classList.remove('desktop-menu-escape-closed');
          }
        }, 0);
      });

      item.addEventListener('keydown', function(event) {
        if (desktopMenuQuery.matches && event.key === 'Escape') {
          if (item.classList.contains('desktop-menu-escape-closed') && event.target === trigger) return;
          event.preventDefault();
          event.stopPropagation();
          item.classList.add('desktop-menu-escape-closed');
          setDesktopMenuState(item, false);
          trigger.focus({ preventScroll: true });
        } else if (desktopMenuQuery.matches && event.key === 'ArrowDown' && event.target === trigger) {
          var firstLink = panel.querySelector('a');
          if (firstLink) {
            event.preventDefault();
            item.classList.remove('desktop-menu-escape-closed');
            setDesktopMenuState(item, true);
            firstLink.focus({ preventScroll: true });
          }
        }
      });
    });

    function megaMenu() {
      if($("#header .page-full-width").length) {
          var parentRow = $("#header .page-full-width > .row");
          var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));
        } else {
          var parentRow = $("#header .page-width .row");
          var parentLeft = parseInt(parentRow.offset().left);
        }
        var parentWidth = parentRow.width();   
  
        $("#header .page-width .dt-nav li:not(.close-nav)").each(function() {
          var thisItem = $(this);
          if(thisItem.hasClass('has-mega-menu')) {
            var thisItemLeft = thisItem.find('a').offset().left;
            var menuLeft = parseInt(thisItemLeft-parentLeft); 
            thisItem.find('.sub-menu-block').css('width', parentWidth);  
            thisItem.find('.sub-menu-block').css('left', -menuLeft);            
          }
        });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function() {
      var thisItem = $(this);
      if(thisItem.hasClass('has-mega-menu')) {
        var thisItemLeft = thisItem.find('a').offset().left;
        var menuLeft = parseInt(thisItemLeft-parentLeft); 
        var menuLeft = menuLeft - 5; 
        thisItem.find('.sub-menu-block').css('width', parentWidth);
        thisItem.find('.sub-menu-block').css('left', -menuLeft);
      }      
    });

    window.setTimeout(function(){
      $(window).trigger('resize');
    }, 800);
  }

  var megaMenuResize = false;
  $(window).bind("resize", function() {
    if(!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
   
});


$(function() {
  if($(window).width() >=  1200) {
     $('.tabs-nav a').click(function() {
    let id = $(this).attr('href');           
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');             
    $(this).parent().parent().parent().parent().addClass('active');   
    $('.tabs-content li.dt-sc-menu-tabs').hide();      
    $(this).parent().parent().parent().parent().find(id).show();
   
    return false;
  });
}
  if($(window).width() <= 1199 ) {
  $('.mobileTabs .tabs  li').each(function(){
    $(this).click(function(){
      $(this).next('div').slideToggle(0);
    });
  })
}
});

$(document).ready(function(){
   $('#category-menu-button').click(function() { 
    $(this).toggleClass('open');
    $(".category-wrapper").toggleClass('open');
    $('.category-wrapper').slideToggle(0);
    });
});
